// extracted by mini-css-extract-plugin
export default {"container":"details-modal_container__mwhGC","overlay":"details-modal_overlay__mNLvH"};